import { SettingsDataSource, ErrorReportResponse, NullSettingsDataSource } from "../datasource/settings";
import { ProductId } from "../datasource";

export abstract class SettingsModel<P extends ProductId> {
	datasource: SettingsDataSource<P>;

	protected constructor(datasource?: SettingsDataSource<P>) {
		this.datasource = datasource ?? new NullSettingsDataSource();
	}

	abstract getKeyboardShortcuts(): boolean;
	abstract setKeyboardShortcuts(enabled: boolean): void;
	abstract getFontSize(): number;
	abstract setFontSize(size: number): void;
	abstract getRandomize(): boolean;
	abstract setRandomize(randomize: boolean): void;
	abstract toggleTimer(): boolean;
	abstract getEmailSuggestion(email: string): Promise<string | undefined>;
	abstract sendErrorReport(product: P, form: HTMLFormElement): Promise<ErrorReportResponse>;
	abstract appendError(error: Error | any): void;
	abstract getErrors(): (Error | any)[];
	abstract clearErrors(): void;
	abstract getLocalStorage(): Record<string, any>;
}

export class NullSettingsModel<P extends ProductId> implements SettingsModel<P> {
	datasource: SettingsDataSource<P>;

	getKeyboardShortcuts(): boolean {
		throw new Error("Method not implemented.");
	}

	setKeyboardShortcuts(enabled: boolean): void {
		throw new Error("Method not implemented.");
	}

	getFontSize(): number {
		throw new Error("Method not implemented.");
	}

	setFontSize(size: number): void {
		throw new Error("Method not implemented.");
	}

	getRandomize(): boolean {
		throw new Error("Method not implemented.");
	}

	setRandomize(randomize: boolean): void {
		throw new Error("Method not implemented.");
	}

	toggleTimer(): boolean {
		throw new Error("Method not implemented.");
	}

	getEmailSuggestion(email: string): Promise<string | undefined> {
		throw new Error("Method not implemented.");
	}

	sendErrorReport(product: P, form: HTMLFormElement): Promise<ErrorReportResponse> {
		throw new Error("Method not implemented.");
	}

	appendError(error: Error | any): void {
		throw new Error("Method not implemented.");
	}

	getErrors(): (Error | any)[] {
		throw new Error("Method not implemented.");
	}

	clearErrors(): void {
		throw new Error("Method not implemented.");
	}

	getLocalStorage(): Record<string, any> {
		throw new Error("Method not implemented.");
	}
}
